import { lazyWithReload } from '@shared/react/lazyWithReload';
import { Route } from 'react-router-dom';

import { businessCreationPath } from './urls';

const BusinessCreationView = lazyWithReload(() =>
  import('./pages/BusinessCreation').then((m) => ({ default: m.BusinessCreationView }))
);

export const BusinessCreationRoutes = (
  <>
    <Route path={businessCreationPath} element={<BusinessCreationView />} />
  </>
);
